import { render, staticRenderFns } from "./input-error.vue?vue&type=template&id=5e8a0b56"
import script from "./input-error.vue?vue&type=script&lang=js"
export * from "./input-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports